"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputLabel = exports.errorContainerCss = exports.StyledInput = exports.InputWrapper = exports.rightIconCss = exports.iconCss = exports.wrapperCss = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

var _eyemobileCore = _interopRequireDefault(require("@bit/eyemobile.core.constants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var inputBorderColor = function inputBorderColor(_ref) {
  var theme = _ref.theme,
      hasError = _ref.hasError,
      valid = _ref.valid,
      disabled = _ref.disabled,
      borderColor = _ref.borderColor;

  if (disabled) {
    return theme && theme.getColor && theme.getColor('disabled') || '#d4d4d4';
  }

  if (hasError) {
    return theme && theme.getColor && theme.getColor('error') || _eyemobileCore["default"].error;
  }

  if (valid) {
    return theme && theme.getColor && theme.getColor('success') || _eyemobileCore["default"].success;
  }

  if (borderColor) {
    return theme && theme.getColor && theme.getColor(borderColor) || borderColor;
  }

  return theme && theme.getColor && theme.getColor('primary') || '#a9a9a9';
};

var inputTextColor = function inputTextColor(_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;

  if (color) {
    return theme && theme.getColor && theme.getColor(color) || color;
  }

  return theme && theme.getColor && theme.getColor('text') || _eyemobileCore["default"].graytext;
};

var getPaddingLeft = function getPaddingLeft(_ref3) {
  var hasIcon = _ref3.hasIcon,
      variant = _ref3.variant;

  if (hasIcon) {
    return '41px';
  }

  if (variant === 'bordered') {
    return '16px';
  }

  return '5px';
};

var getPaddingRight = function getPaddingRight(_ref4) {
  var hasRightIcon = _ref4.hasRightIcon,
      variant = _ref4.variant;

  if (hasRightIcon) {
    return '41px';
  }

  if (variant === 'bordered') {
    return '16px';
  }

  return '5px';
};

var labelColor = function labelColor(_ref5) {
  var theme = _ref5.theme,
      disabled = _ref5.disabled,
      color = _ref5.color;

  if (disabled) {
    return theme && theme.getColor && theme.getColor('disabled') || '#d4d4d4';
  }

  if (color) {
    return theme && theme.getColor && theme.getColor(color) || color;
  }

  return theme && theme.getColor && theme.getColor('primary') || '#8e8e8e';
};

var variants = {
  "default": {
    borderBottom: '1px solid'
  },
  bordered: {
    border: '1px solid',
    borderRadius: '19px'
  }
};
var wrapperCss = {
  name: "2wymm3-wrapperCss",
  styles: "position:relative;display:inline-flex;align-items:center;width:100%;margin-top:5px;margin-bottom:8px;*{box-sizing:border-box;};label:wrapperCss;"
};
exports.wrapperCss = wrapperCss;
var iconCss = {
  name: "natvld-iconCss",
  styles: "position:absolute;top:50%;left:12px;display:block;flex-shrink:0;object-fit:contain;width:24px;height:24px;display:flex;align-items:center;justify-content:center;transform:translateY(-50%);;label:iconCss;"
};
exports.iconCss = iconCss;
var rightIconCss = {
  name: "1dhsbwo-rightIconCss",
  styles: "position:absolute;top:50%;right:12px;display:block;flex-shrink:0;object-fit:contain;width:24px;height:24px;display:flex;align-items:center;justify-content:center;transform:translateY(-50%);;label:rightIconCss;"
};
exports.rightIconCss = rightIconCss;
var InputWrapper = (0, _styledBase["default"])("div", {
  target: "ez9glmw0",
  label: "InputWrapper"
})({
  name: "1jke4yk",
  styles: "position:relative;width:100%;"
});
exports.InputWrapper = InputWrapper;
var StyledInput = (0, _styledBase["default"])("input", {
  target: "ez9glmw1",
  label: "StyledInput"
})("font-family:", function (_ref6) {
  var theme = _ref6.theme;
  return theme && theme.getFont && theme.getFont() || 'Arial, Helvetica, sans-serif';
}, ";font-size:", function (_ref7) {
  var theme = _ref7.theme;
  return theme && theme.getFontSize && theme.getFontSize(1.15, 'px') || '16px';
}, ";width:100%;border:none;color:", inputTextColor, ";height:35px;padding-left:", function (_ref8) {
  var hasIcon = _ref8.hasIcon,
      variant = _ref8.variant;
  return getPaddingLeft({
    hasIcon: hasIcon,
    variant: variant
  });
}, ";padding-right:", function (_ref9) {
  var hasRightIcon = _ref9.hasRightIcon,
      variant = _ref9.variant;
  return getPaddingRight({
    hasRightIcon: hasRightIcon,
    variant: variant
  });
}, ";background-color:", function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled ? 'rgba(0, 0, 0, 0.05)' : 'transparent';
}, ";outline:none;", function (_ref11) {
  var variant = _ref11.variant;
  return variants[variant];
}, " border-color:", inputBorderColor, ";resize:none;");
exports.StyledInput = StyledInput;

var errorContainerCss = function errorContainerCss(theme) {
  return /*#__PURE__*/(0, _core.css)("color:", theme && theme.getColor && theme.getColor('error') || '#ff4f65', ";font-size:", theme && theme.getFontSize && theme.getFontSize(1, 'px') || '14px', ";position:absolute;padding-left:5px;padding-top:5px;");
};

exports.errorContainerCss = errorContainerCss;
var InputLabel = (0, _styledBase["default"])("label", {
  target: "ez9glmw2",
  label: "InputLabel"
})("font-family:", function (_ref12) {
  var theme = _ref12.theme;
  return theme && theme.getFont && theme.getFont() || 'Futura, Arial, Helvetica, sans-serif';
}, ";font-size:100%;color:", labelColor, ";position:absolute;left:0;top:50%;transform:translate(12px,-50%);transition:transform 0.2s,font-size 0.2s;cursor:text;z-index:10;padding-left:4px;padding-right:4px;border-radius:10px;background-color:", function (_ref13) {
  var theme = _ref13.theme,
      backgroundColor = _ref13.backgroundColor;
  return backgroundColor && theme && theme.getColor && theme.getColor(backgroundColor) || '#ffffff';
}, ";", function (_ref14) {
  var animated = _ref14.animated;
  return animated && 'font-size: 10px; transform: translate(12px, calc(-50% - 20px));';
});
exports.InputLabel = InputLabel;

//# sourceMappingURL=EyeInput.styles.js.map